/* Shivansh Electronics - own theme behaviour (drawer, explore strip, gallery, tabs, sort, filters, quantity) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const FILES = window.SE_FILES_URL || '';

  /* menu drawer */
  const openDrawer = () => document.body.classList.add('open');
  const closeDrawer = () => document.body.classList.remove('open');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-se-open-drawer]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-se-close-drawer]')) { e.preventDefault(); closeDrawer(); }
    const mi = e.target.closest('.drawer .mi[data-se-toggle]');
    if (mi) { e.preventDefault(); mi.classList.toggle('on'); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeSearch(); } });

  /* search drawer from the right (like the previous site), with live product suggestions */
  const openSearch = () => { document.body.classList.add('sopen'); setTimeout(() => { const i = $('.se-sd__in'); if (i) i.focus(); }, 60); };
  const closeSearch = () => document.body.classList.remove('sopen');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-se-open-search]') && $('.se-sd')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-se-close-search]')) { e.preventDefault(); closeSearch(); }
  });
  let sT, sQ = '';
  const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const inr = (v, t) => { const n = Math.round(parseFloat(v) || 0); const lab = /^MOTU/i.test(t || '') ? 'OFFER PRICE' : /^MOJAVE/i.test(t || '') ? 'LIST PRICE' : 'MRP';
    return n ? lab + ' - Rs. ' + n.toLocaleString('en-IN') : 'Price on request'; };
  document.addEventListener('input', (e) => {
    if (!e.target.matches('.se-sd__in')) return;
    clearTimeout(sT);
    const q = e.target.value.trim(), box = $('.se-sd__res');
    if (q.length < 2) { box.innerHTML = ''; sQ = ''; return; }
    sT = setTimeout(async () => {
      sQ = q;
      try {
        const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last');
        const d = await r.json(); if (q !== sQ) return;
        const P = (d.resources.results.products || []);
        /* one page per name: if two collections share a title, keep the brand page (brands-...) and drop the other */
        const seen = {}, C = [];
        (d.resources.results.collections || []).sort((a, b) => (/^brands-/.test(b.handle) ? 1 : 0) - (/^brands-/.test(a.handle) ? 1 : 0))
          .forEach((c) => { const k = (c.title || '').trim().toUpperCase(); if (k && !seen[k] && c.handle !== 'all') { seen[k] = 1; C.push(c); } });
        let h = '';
        if (C.length) h += '<p class="se-sd__h">Categories &amp; brands</p><div class="se-sd__cols">' + C.slice(0, 6).map((c) => '<a href="' + c.url + '">' + esc(c.title) + '</a>').join('') + '</div>';
        if (P.length) h += '<p class="se-sd__h">Products</p>' + P.map((p) => '<a class="se-sd__p" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + (p.image.includes('?') ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '<span></span>') + '<span><b>' + esc(p.title) + '</b><em>' + inr(p.price, p.title) + '</em></span></a>').join('');
        h += '<a class="se-sd__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">' + (P.length ? 'View all results for “' + esc(q) + '”' : 'No quick matches. Search all products for “' + esc(q) + '”') + ' →</a>';
        box.innerHTML = h;
      } catch (err) { box.innerHTML = ''; }
    }, 220);
  });

  /* scrollbar width, used by full-width bands */
  const setSB = () => document.documentElement.style.setProperty('--sb', (innerWidth - document.documentElement.clientWidth) + 'px');

  /* "Explore all categories": pick the strip with as many category tiles as fit */
  const fitX = () => $$('.xcat').forEach((a) => {
    const w = a.clientWidth; if (!w) return;
    const th = parseFloat(getComputedStyle(a).getPropertyValue('--th')) || 64;
    let n = Math.round((((w - 32) / th) * 272 - 16) / 236);
    n = Math.max(3, Math.min(14, n));
    a.style.setProperty('--xs', `url('${FILES}EXPLORE-ALL-CATEGORIES-STRIP-${String(n).padStart(2, '0')}.webp?width=${Math.min(3400, n * 236 + 16)}')`);
  });

  /* product gallery: one scrolling thumbnail row */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.thumbs img');
    if (t) {
      const main = $('#se-mainimg'); if (main) { main.src = t.dataset.full; main.srcset = ''; main.dataset.zoom = t.dataset.zoom || t.dataset.full; }
      $$('.thumbs img').forEach((x) => x.classList.remove('on')); t.classList.add('on');
      t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    const ar = e.target.closest('.tw .ar');
    if (ar) { const row = $('.thumbs'); row.scrollBy({ left: (ar.classList.contains('l') ? -1 : 1) * row.clientWidth, behavior: 'smooth' }); }

    /* product tabs */
    const tab = e.target.closest('.tabbar b');
    if (tab) {
      $$('.tabbar b, .tabs .panel').forEach((x) => x.classList.remove('on'));
      tab.classList.add('on'); const p = $$('.tabs .panel')[+tab.dataset.i]; if (p) p.classList.add('on');
    }

    /* sort popover */
    const sb = e.target.closest('[data-se-sort]');
    if (sb) { e.preventDefault(); $('#se-sortpop')?.classList.toggle('on'); }
    else if (!e.target.closest('#se-sortpop')) $('#se-sortpop')?.classList.remove('on');

    /* filters panel show / hide */
    if (e.target.closest('[data-se-filters]')) { e.preventDefault(); $('.cl')?.classList.toggle(innerWidth < 1000 ? 'fopen' : 'nof'); syncFbtn(); }
    if (e.target.closest('[data-se-close-filters]') || e.target.matches('.cl.fopen')) { e.preventDefault(); $('.cl')?.classList.remove('fopen'); syncFbtn(); }

    /* quantity */
    const q = e.target.closest('[data-se-qty]');
    if (q) {
      const inp = $('#se-qty'); const v = Math.max(1, (+inp.value || 1) + (+q.dataset.seQty));
      inp.value = v; $('#se-qty-show').textContent = v;
    }
  });

  /* filters: apply on change (storefront filtering is a plain GET form) */
  /* price boxes: Indian commas while typing (1,00,00,000), plain digits when the filter is applied */
  const inrFmt = (v) => { const d = String(v || '').replace(/[^0-9]/g, ''); return d ? Number(d).toLocaleString('en-IN') : ''; };
  const inrPlain = (f) => $$('[data-se-inr]', f).forEach((i) => { i.value = i.value.replace(/[^0-9]/g, ''); });
  const inrInit = () => $$('[data-se-inr]').forEach((i) => { i.value = inrFmt(i.value); if (i.placeholder && /^[0-9]+$/.test(i.placeholder)) i.placeholder = inrFmt(i.placeholder); });
  document.addEventListener('input', (e) => { if (e.target.matches('[data-se-inr]')) e.target.value = inrFmt(e.target.value); });
  document.addEventListener('submit', (e) => { if (e.target.matches('form[data-se-filter-form]')) inrPlain(e.target); });
  document.addEventListener('DOMContentLoaded', inrInit);
  document.addEventListener('change', (e) => { const f = e.target.closest('form[data-se-filter-form]'); if (f) { inrPlain(f); f.submit(); } });

  /* footer "Explore all categories" box: same tile-strip sizing as the previous site's footer */
  const fitFoot = () => $$('.se-nav-all:not(.sef__allbrands)').forEach((a) => {
    const w = a.clientWidth, h = a.clientHeight; if (!w) return;
    const pc = innerWidth >= 750;
    const th = innerWidth >= 750 ? 64 : 54;           /* picture row height */
    let n = pc ? Math.round((((w - 16) / th) * 272 - 16) / 236) : Math.round(((w / h) * 272 - 16) / 236);
    n = Math.max(3, Math.min(14, n));
    if (pc) { const sw = th * (n * 236 + 16) / 272; a.style.setProperty('--se-sz', sw > w - 16 ? (w - 16) + 'px auto' : 'auto ' + th + 'px'); }
    a.style.setProperty('--se-strip', `url('${FILES}EXPLORE-ALL-CATEGORIES-STRIP-${String(n).padStart(2, '0')}.webp?width=${Math.min(3400, n * 236 + 16)}')`);
  });

  /* floating Call / WhatsApp buttons step aside while the footer (which has its own buttons) is on screen */
  const watchFooter = () => {
    const f = $('.sef'); if (!f || watchFooter.done) return; watchFooter.done = true;
    const check = () => document.body.classList.toggle('se-foot-in', f.getBoundingClientRect().top < innerHeight - 40);
    addEventListener('scroll', check, { passive: true }); addEventListener('resize', check); check();
  };

  /* homepage rows after the first few: fetched only when the visitor scrolls within ~1.5 screens of them */
  /* homepage rows: fetched a few at a time, nearest first, starting a few screens ahead so they are ready before the
     visitor reaches them (a fast scroll used to fire dozens of requests at once and leave empty rows) */
  let rowsBusy = 0;
  const loadRows = () => {
    const wait = $$('.se-row-wait[data-se-row]').filter((el) => !el.dataset.loading)
      .map((el) => [el, el.getBoundingClientRect().top]).filter(([, t]) => t < innerHeight * 4)
      .sort((a, b) => Math.abs(a[1]) - Math.abs(b[1]));
    for (const [el] of wait) {
      if (rowsBusy >= 3) break;
      rowsBusy++; el.dataset.loading = '1';
      fetch(el.dataset.seRow).then((r) => { if (!r.ok) throw r; return r.text(); }).then((html) => {
        const box = document.createElement('div'); box.innerHTML = html;
        const row = box.querySelector('.hrow-g'); if (row) el.replaceWith(row); else el.remove();
      }).catch(() => { el.dataset.tries = (+el.dataset.tries || 0) + 1; if (el.dataset.tries < 4) setTimeout(() => { delete el.dataset.loading; loadRows(); }, 1200); })
        .finally(() => { rowsBusy--; loadRows(); });
    }
  };
  /* card hover picture: load it the first time the card is pointed at */
  document.addEventListener('mouseover', (e) => {
    const i = e.target.closest('.mc') && e.target.closest('.mc').querySelector('img.i2[data-src]'); if (!i) return;
    if (i.dataset.srcset) i.srcset = i.dataset.srcset; i.src = i.dataset.src; i.removeAttribute('data-src'); i.removeAttribute('data-srcset');
  });
  /* capture: also hears scrolling inside any box, not only the page */
  document.addEventListener('scroll', loadRows, { passive: true, capture: true });

  /* Filters button shows whether the panel is open (navy) or closed (white) */
  const syncFbtn = () => { const cl = $('.cl'), b = $('.fbtn'); if (!cl || !b) return;
    const open = innerWidth < 1000 ? cl.classList.contains('fopen') : !cl.classList.contains('nof');
    b.classList.toggle('on', open); b.setAttribute('aria-expanded', open); };
  /* heights of the sticky header and toolbar, so the toolbar and filters panel stick right under them */
  const setSticky = () => { const h = $('#header-group') || $('header.se-site-head'); const bar = $('.se-cbar-s');
    document.documentElement.style.setProperty('--se-head', (h ? Math.round(h.getBoundingClientRect().height) : 0) + 'px');
    if (bar) document.documentElement.style.setProperty('--se-bar', Math.round(bar.getBoundingClientRect().height) + 'px'); };
  /* phones: long banner descriptions are cut to 3 lines with a Read more / Show less button */
  const clampDesc = () => $$('.bhero .bdsc, .cbanner--show .cd').forEach((d) => {
    if (d.dataset.clampDone) return;
    if (innerWidth >= 750) return;
    d.classList.add('se-clamp');
    if (d.scrollHeight <= d.clientHeight + 4) { d.classList.remove('se-clamp'); return; }
    d.dataset.clampDone = '1';
    const b = document.createElement('button'); b.type = 'button'; b.className = 'se-more'; b.textContent = 'Read more';
    b.addEventListener('click', () => { const o = d.classList.toggle('open'); b.classList.toggle('open', o); b.textContent = o ? 'Show less' : 'Read more'; });
    d.after(b);
  });
  /* full-screen photo viewer: tap the main photo; arrows / swipe / keys move between photos; tap the photo to zoom */
  const lb = $('.se-lb');
  if (lb) {
    const pics = () => $$('.thumbs img').map((t) => t.dataset.zoom || t.dataset.full);
    let idx = 0;
    const show = (i) => { const p = pics(); if (!p.length) return; idx = (i + p.length) % p.length; const im = $('.se-lb-img');
      im.classList.remove('z'); im.style.transformOrigin = ''; im.src = p[idx]; $('.se-lb-n').textContent = (idx + 1) + ' / ' + p.length; };
    const open = () => { const all = $$('.thumbs img'); show(Math.max(0, all.indexOf($('.thumbs img.on')))); lb.hidden = false; document.body.classList.add('lb-open'); };
    const close = () => { lb.hidden = true; document.body.classList.remove('lb-open'); };
    $('#se-mainimg')?.addEventListener('click', open);
    const origin = (im, e) => { const r = im.getBoundingClientRect(); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; };
    lb.addEventListener('click', (e) => {
      if (e.target.closest('.se-lb-x') || e.target === lb || e.target.classList.contains('se-lb-stage')) return close();
      const a = e.target.closest('.se-lb-a'); if (a) return show(idx + (a.classList.contains('l') ? -1 : 1));
      const im = e.target.closest('.se-lb-img'); if (im) { origin(im, e); im.classList.toggle('z'); }
    });
    lb.addEventListener('mousemove', (e) => { const im = $('.se-lb-img.z'); if (im) { const r = im.parentElement.getBoundingClientRect(); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; } });
    let sx = null;
    lb.addEventListener('touchstart', (e) => { sx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    lb.addEventListener('touchend', (e) => { if (sx === null || $('.se-lb-img.z')) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1)); sx = null; });
    document.addEventListener('keydown', (e) => { if (lb.hidden) return; if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); });
  }

  /* sticky Add to cart bar: shown once the page's own buttons have scrolled above the screen (hidden over the footer) */
  const ssb = $('.se-sticky-buy'), buyRow = $('.info .buy');
  if (ssb && buyRow) {
    const chk = () => { const ft = $('.sef'); const on = buyRow.getBoundingClientRect().bottom < 0 && !(ft && ft.getBoundingClientRect().top < innerHeight - 40);
      ssb.classList.toggle('on', on); ssb.setAttribute('aria-hidden', String(!on)); document.body.classList.toggle('ssb-on', on); };
    addEventListener('scroll', chk, { passive: true }); addEventListener('resize', chk); chk();
    ssb.addEventListener('click', (e) => { if (!e.target.closest('[data-se-sticky-add]')) return; const b = $('#se-product-form button[type=submit]'); if (b) b.click(); });
  }

  /* product tabs: show the short names only when the full names no longer fit on one line */
  const fitTabs = () => $$('.tabbar').forEach((t) => {
    if (!t.querySelector('.tl-f')) return;
    t.classList.remove('tl-short');
    const fits = t.scrollWidth <= t.clientWidth + 1 && $$('b', t).every((b) => b.scrollWidth <= b.clientWidth + 1);
    t.classList.toggle('tl-short', !fits);
  });
  const init = () => { fitTabs(); clampDesc(); setSB(); fitX(); fitFoot(); watchFooter(); loadRows(); syncFbtn(); setSticky(); };
  addEventListener('load', init); addEventListener('resize', init); document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('click', () => setTimeout(fitX, 350));
})();
